const CATEGORY_EN = {
  abrigos: "Shelters",
  "aldeias históricas": "Historic villages",
  alimentação: "Food",
  alojamentos: "Accommodation",
  "área de lazer": "Recreation areas",
  "áreas de lazer": "Recreation areas",
  baloiços: "Swings",
  bancos: "Benches",
  bosques: "Woodlands",
  brandas: "Seasonal villages",
  camping: "Campsites",
  cascatas: "Waterfalls",
  castelos: "Castles",
  cumes: "Summits",
  currais: "Mountain corrals",
  farmácias: "Pharmacies",
  fojo: "Wolf traps",
  fojos: "Wolf traps",
  lagoas: "Lagoons",
  "locais religiosos": "Religious sites",
  minas: "Mines",
  miradouro: "Viewpoints",
  miradouros: "Viewpoints",
  moinhos: "Mills",
  "monumentos naturais": "Natural monuments",
  "obras monumentais": "Monumental works",
  pontes: "Bridges",
  "pontos de água": "Water points",
  poço: "Wells",
  poços: "Wells",
  praias: "Beaches",
  refeições: "Food",
  silhas: "Bee walls",
  transportes: "Transport",
  outros: "Other",
};

const clean = (value) => String(value || "").trim();
const normalized = (value) => clean(value).toLocaleLowerCase("pt-PT");

export function localizedWaypointName(waypoint, language = "pt") {
  if (language !== "en") return clean(waypoint?.name) || "Waypoint";
  return clean(waypoint?.translations?.en?.name || waypoint?.nameEn || waypoint?.name) || "Waypoint";
}

export function localizedWaypointDescription(waypoint, language = "pt") {
  if (language !== "en") {
    return clean(waypoint?.desc || waypoint?.description || waypoint?.details || waypoint?.text || waypoint?.note);
  }
  const english = waypoint?.translations?.en || {};
  return clean(
    english.desc || english.description || english.details || english.text || english.note ||
    waypoint?.descriptionEn || waypoint?.descEn
  );
}

export function localizedWaypointCategory(value, language = "pt", waypoint = null) {
  const original = clean(value);
  if (language !== "en") return original;
  const stored = clean(waypoint?.translations?.en?.categoryName);
  return stored || CATEGORY_EN[normalized(original)] || original;
}
